import React from 'react';
import { useApp } from '../../context/AppContext';
import { statusOptions } from '../../mock';
import { Calendar, Mail } from 'lucide-react';

export default function KanbanView({ onSelect }) {
  const { filteredGuests, activeShow, updateGuest } = useApp();

  const grouped = statusOptions.map(s => ({
    ...s,
    items: filteredGuests.filter(g => g.status === s.value)
  }));

  const onDragStart = (e, id) => e.dataTransfer.setData('id', id);
  const onDrop = (e, status) => {
    const id = e.dataTransfer.getData('id');
    if (id) updateGuest(id, { status });
  };

  return (
    <div className="p-4 overflow-auto h-full">
      <div className="flex gap-4 min-w-max h-full">
        {grouped.map(col => (
          <div
            key={col.value}
            className="w-[280px] shrink-0 bg-stone-50 rounded-lg border border-stone-200 flex flex-col"
            onDragOver={(e) => e.preventDefault()}
            onDrop={(e) => onDrop(e, col.value)}
          >
            <div className="px-3 py-2.5 flex items-center justify-between border-b border-stone-200">
              <div className="flex items-center gap-2">
                <span className="w-2 h-2 rounded-full" style={{ background: col.color }} />
                <span className="text-[12px] font-semibold text-stone-800">{col.label}</span>
              </div>
              <span className="text-[11px] text-stone-500">{col.items.length}</span>
            </div>
            <div className="p-2 space-y-2 overflow-auto">
              {col.items.map(g => (
                <div
                  key={g.id}
                  draggable
                  onDragStart={(e) => onDragStart(e, g.id)}
                  onClick={() => onSelect(g.id)}
                  className="bg-white border border-stone-200 rounded-md p-2.5 hover:shadow-md transition-shadow cursor-pointer"
                >
                  <div className="flex items-center gap-2 mb-1.5">
                    {g.avatar ? <img src={g.avatar} className="w-6 h-6 rounded-full object-cover" alt="" /> :
                      <div className="w-6 h-6 rounded-full text-white text-[10px] grid place-items-center font-bold" style={{ background: activeShow.color }}>{g.name[0]}</div>}
                    <div className="text-[12.5px] font-medium text-stone-900 truncate">{g.name}</div>
                  </div>
                  <div className="text-[11.5px] text-stone-600 truncate mb-2">{g.episodeTitle || 'No title yet'}</div>
                  <div className="flex items-center gap-2 text-[10.5px] text-stone-500">
                    {g.episodeDate && <span className="flex items-center gap-1"><Calendar className="w-3 h-3" />{g.episodeDate}</span>}
                    <span className="flex items-center gap-1"><Mail className="w-3 h-3" /> {g.releaseStatus}</span>
                  </div>
                </div>
              ))}
              {col.items.length === 0 && <div className="text-[11px] text-stone-400 text-center py-4">Drop here</div>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
